/**
 * Checks if a product variant is ready to be shipped
 * @param {Object} variant - The variant object to check.
 * @param {boolean} variant.available
 * @param {boolean} variant.isPreorder
 * @param {boolean} variant.isMadeToOrder
 * @returns {boolean} - Returns true if the variant is ready to ship (available, not preorder, and not made to order)
 */

export const isVariantReadyToShip = (variant) => {
  const { available, isPreorder, isMadeToOrder } = variant;
  return available && isPreorder === false && isMadeToOrder === false;
};

export default {};
